import { render, staticRenderFns } from "./Counters.vue?vue&type=template&id=251ffbd8"
import script from "./Counters.vue?vue&type=script&lang=js"
export * from "./Counters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports